import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, Subject, Subscription, timer} from "rxjs";

import {isEqualOrBothUndefined} from "../shared/defines/common.func";
import {
  BODY_HEIGHT_CAL,
  BODY_HEIGHT_VALUE,
  EXT_HEIGHT_CAL,
  LIST_SCROLL_INTERVAL,
  MENU_PAGE, SIDE_HEIGHT_DELTA,
  WORD_SCROLL_SPEED
} from "../shared/defines/desktop.const";
import {HISTORY_KEY_SEARCH_TOTAL, LIST_TYPE, SearchParam, UI_RELOAD_HEIGHT} from "../shared/defines/client.const";
import {TotalLinkInfo, TotalLinkParam, TotalService} from "../shared/services/total/total.service";
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {GlobalEventService} from "../shared/services/global-event/global-event.service";
import {LayoutMgrService} from "../shared/services/layout-mgr/layout-mgr.service";
import {SearchBoxComponent} from "../shared/components/search-box/search-box.component";
import {filter, finalize, takeUntil} from "rxjs/operators";
import {VoiceService} from "../shared/services/voice/voice.service";
import {SimpleWord} from "../shared/models/simple-word.model";
import {SimpleDialect} from "../shared/models/dialect.model";
import {HttpErrorResponse} from "@angular/common/http";
import {WordDetailComponent} from "../shared/components/word-detail/word-detail.component";

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('main', { static: true }) main?: ElementRef; // ngOnInit() 에서 사용 가능
  @ViewChild('container') container?: ElementRef; // ngAfterViewInit() 에서 사용 가능
  @ViewChild('innerScroll') innerScroll?: ElementRef; // ngAfterViewInit() 에서 사용 가능

  // 화면 사이즈 맞춤에 사용
  @ViewChild('extContainer') extContainer?: ElementRef;
  @ViewChild(SearchBoxComponent) extHeader?: SearchBoxComponent;
  @ViewChild('extBody') extBody?: ElementRef;
  @ViewChild('extBody2') extBody2?: ElementRef;
  @ViewChild('wordDetail', { static: false }) wordDetail?: WordDetailComponent;

  protected readonly LIST_TYPE = LIST_TYPE;

  public selectedMenu: MENU_PAGE = MENU_PAGE.NONE;

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam | null = null;

  // 라우터 처리 코드가 불려졌는지 여부
  private inited = false;

  // 검색창에 넣는 값
  public keyword: string | null = null;
  public placeholder: string | null = '검색 합니다.';
  readonly HISTORY_KEY_SEARCH_TOTAL = HISTORY_KEY_SEARCH_TOTAL;
  protected scrollTop = true;

  // 소리 자동 재생 관련
  protected autoPlay = false; // 화면에 처음 들어왔을 때, 자동 재생을 막는 변수.
  private lazyAutoPlay = false;

  // 로딩 중 처리
  public get IsLoading(): boolean {
    return this.totalLinkInfo === null && this.linkSearch$ !== null;
  }
  private linkSearch$: Subscription | null = null;

  // 로딩 완료 시마다 불려짐
  protected loadComplete$ = new BehaviorSubject<boolean>(false);

  public totalLinkInfo: TotalLinkInfo | null = null;


  curDetail: SimpleWord | SimpleDialect | null = null;
  public get curWord(): SimpleWord | null {
    return this.curDetail instanceof SimpleWord ? this.curDetail : null;
  }
  public get curDialect(): SimpleDialect | null {
    return this.curDetail instanceof SimpleDialect ? this.curDetail : null;
  }

  // 라우딩 처리
  private routerStop$ = new Subject();
  private queryParams$?: Subscription;
  private params$?: Subscription;


  // 화면 크기 조정
  private bodyHeight = UI_RELOAD_HEIGHT;

  // 스크롤 처리
  private scrollDownInterval: any = null;

  protected showScrollDown = false;


  get countWord(): number {
    return this.totalLinkInfo?.word?.length ?? 0;
  }
  get listWord(): Array<SimpleWord> | null {
    return this.totalLinkInfo?.word ?? null;
  }
  get lastWord(): SimpleWord | null {
    const listWord = this.totalLinkInfo?.word ?? null;
    return (listWord && listWord.length > 0) ? listWord[listWord.length - 1] : null;
  }

  get countDialect(): number {
    return this.totalLinkInfo?.dialect?.length ?? 0;
  }
  get listDialect(): Array<SimpleDialect> | null {
    return this.totalLinkInfo?.dialect ?? null;
  }
  get lastDialect(): SimpleDialect | null {
    const listDialect = this.totalLinkInfo?.dialect ?? null;
    return (listDialect && listDialect.length > 0) ? listDialect[listDialect.length - 1] : null;
  }



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private voice: VoiceService,
    private totalSvc: TotalService,
    private globalEventSvc: GlobalEventService,
    public lm: LayoutMgrService,
  ) {
    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        console.log('LinkComponent::queryParams =', this.inited, params, this.queryParams);

        const oldParams = this.queryParams;
        this.queryParams = {...params};

        if (this.inited) {
          // 라우터 주소 변경 핸들러로 들어와서 init()이 처음 불려진 경우 = 이미 화면이 목록이 불려진 경우 = 목록이 초기화되어있는 경우!
          // 이 조건을 안 걸면 init()가 두번 불려진다.

          if (!isEqualOrBothUndefined(params['wids'], oldParams?.wids)
            || !isEqualOrBothUndefined(params['dids'], oldParams?.dids))
          {
            // 다시 서버에서 받아온다.
            console.warn('LinkComponent::this.route.queryParams = keyword changed. reload list.');

            // id 지정된 것이 있다면 지운다
            delete this.queryParams['wid'];
            delete this.queryParams['did'];

            // 열려있는 상세 창이 있다면 닫는다.
            this.curDetail = null;

            this.init();
          }
          else if (!('wid' in params || 'did' in params)) {
            this.curDetail = null;
          }

          this.openDetail();
        }
      });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다. (여기서는 type만 변경되어도 불려짐)
     *
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.params$ = route.params.subscribe(params => {
      console.log('LinkComponent::params =', params, this.queryParams);
      this.inited = true;

      this.init();
    });


    /**
     * 로딩이 완료될 때마다 불려짐
     */
    this.loadComplete$.subscribe(() => this.openDetail());
  }

  ngOnInit(): void {

    // 페이지를 이동하면 소리를 멈추도록 구현
    // TODO: 이 부분은 좀 더 정밀하게 할 필요가 있다. 내 컴포넌트(LinkComponent)인 경우에만 처리하도록 수정할 필요가 있다.
    this.router.events.pipe(
      takeUntil(this.routerStop$),
      filter(event => event instanceof NavigationStart || event instanceof NavigationEnd),
    ).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.voice.Stop();
      }
      // else if (event instanceof NavigationEnd) {
      //
      // }
    });

    // if (this.main) {
    //   this.InitFocusMain(this.main);
    // }
    // else {
    //   console.error('LinkComponent::ngOnInit() main is null');
    // }
  }

  ngAfterViewInit(): void {
    this.updateExtHeight();

    // 최초 로딩 시, 화면 배치가 어그러지는 것을 고치기위한 코드. (TODO: 효과 있는지 확인 후 필요시 제거)
    timer(2000).subscribe(() => {
      this.updateExtHeight();
    });
  }

  ngOnDestroy(): void {
    // if (this.getNextList$) {
    //   this.getNextList$.unsubscribe();
    //   this.getNextList$ = null;
    // }

    // 나가기 전에 창 닫기처리.
    // this.CloseDetail();

    // router 이동 체크를 중지함.
    this.routerStop$.next(null);

    // this.ExitFocusMain();

    this.queryParams$?.unsubscribe();
    this.params$?.unsubscribe();
  }

  /**
   * 저장된 searchParam(라우팅에서 전달받은 옵션)을 이용해서 페이지를 재 초기화하고 다시 로딩한다.
   */
  private init(): void {
    const queryParams = this.queryParams;
    const param: SearchParam = {
      ...(queryParams?.wids ? {wids: queryParams.wids} : {}),
      ...(queryParams?.dids ? {dids: queryParams.dids} : {}),
    }
    console.log(`keyword=${this.keyword}, param=${JSON.stringify(param)}`, this);
    this.ReloadList(param);
  }

  private ReloadList(param: SearchParam) {
    console.warn('LinkComponent::ReloadList() = ', param);

    if (param.wids || param.dids) {
      const linkInfo: TotalLinkParam = {
        ...(param?.wids ? {wordIds: param.wids.split(',')} : {}),
        ...(param?.dids ? {dialectIds: param.dids.split(',')} : {}),
      }

      this.linkSearch$ = this.totalSvc.GetLinkInfo(linkInfo).pipe(
        finalize(() => {
          this.linkSearch$ = null;
        })
      ).subscribe(
        data => {
          console.log(data);
          this.totalLinkInfo = data;
          this.loadComplete$.next(true);
        },
        (err: HttpErrorResponse) => {
          if (err.status === 404) {
            this.totalLinkInfo = null;
            this.loadComplete$.next(false);
          }
          else {
            // TODO: 에러 출력
            console.error(err);
          }
        }
      );

      this.autoPlay = false;
      this.lazyAutoPlay = false;
    }
    else {
      console.error('LinkComponent::ReloadList() param does not contain wids or dids', param);
    }
  }

  private openDetail(): void {
    if (this.queryParams?.wid) {
      this.curDetail = this.listWord?.find(w => w.id === this.queryParams?.wid) ?? null;
    }
    else if (this.queryParams?.did) {
      this.curDetail = this.listDialect?.find(d => d.id === this.queryParams?.did) ?? null;
    }

    /**
     * 화면에 처음 들어올 때는 자동 재생을 막고, 그 다음부터 자동 재생 되도록 한다.
     * 화면에 처음 들어올 때, 무조건 첫번째 항목을 상세 화면에 표시하도록 되어있다. 이때는 소리 안 나야 함.
     */
    if (!this.lazyAutoPlay) {
      this.lazyAutoPlay = true;
    }
    else {
      this.autoPlay = true;
    }
  }

  onSearch(param: SearchParam) {
    console.log('LinkComponent::onSearch() = ', param);

    if ('keyword' in param) {
      this.router.navigate(['/total'], {
        queryParams: {...param}
      }).then();
    }
  }

  onSelectWord($event: MouseEvent, word: SimpleWord): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    console.log('LinkComponent::onSelectWord', word);

    const queryParams = {
      ...this.queryParams,
      wid: word.id
    };
    delete queryParams['did'];  // id는 한번에 하나만 지정해야 함.
    this.router.navigate(['/link'], {queryParams}).then();

    // 이미 로딩된 단어는 바로 소리를 재생한다.
    if (this.curDetail === word
      && this.voice.wordId !== word?.id  // 소리가 재생되고 있지 않을 때에만 재생한다.
    ) {
      this.wordDetail?.PlayWord();
    }
  }

  onSelectDialect($event: MouseEvent, dialect: SimpleDialect): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    console.log('LinkComponent::onSelectDialect', dialect);

    const queryParams = {
      ...this.queryParams,
      did: dialect.id
    };
    delete queryParams['wid'];  // id는 한번에 하나만 지정해야 함.
    this.router.navigate(['/link'], {queryParams}).then();
  }


  /****************************************************************************
   * 스크롤 처리
   ****************************************************************************/

  protected onScrollTop($event: Event): void {
    const target = $event.target as HTMLElement;

    // console.log('onScrollTop() ', target.scrollTop);
    this.scrollTop = target.scrollTop === 0; // 수직 스크롤 위치
  }


  onClickRope($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.container?.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth',
      // behavior: 'auto',
    });
  }

  onStartScrollDown($event: MouseEvent|TouchEvent) {
    // console.warn('onStartScrollDown()', $event);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    // 한번은 바로 내려간다.
    this.container?.nativeElement.scrollTo({
      top: this.container.nativeElement.scrollTop + WORD_SCROLL_SPEED * 2,
      behavior: 'auto',
    });

    this.scrollDownInterval = setInterval(() => {
      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + WORD_SCROLL_SPEED,
        behavior: 'auto',
      });
    }, LIST_SCROLL_INTERVAL);
  }

  onEndScrollDown($event: MouseEvent|TouchEvent) {
    // console.warn('onEndScrollDown()', $event);
    clearInterval(this.scrollDownInterval);
    this.scrollDownInterval = null;
  }

  onWordViewInit(word: SimpleWord) {
    if (word.id === this.lastWord?.id) {
      timer(0).subscribe(() => {
        this.showScrollDown = this.innerScroll?.nativeElement.offsetHeight > this.container?.nativeElement.offsetHeight;
      });
    }
  }

  onDialectViewInit(dialect: SimpleDialect) {
    if (dialect.id === this.lastDialect?.id) {
      timer(0).subscribe(() => {
        this.showScrollDown = this.innerScroll?.nativeElement.offsetHeight > this.container?.nativeElement.offsetHeight;
      });
    }
  }

  /****************************************************************************
   * 브라우저 크기 변경 처리.
   ****************************************************************************/


  // 'resize' 이벤트를 감지하고 이벤트 발생 시 updateHeight 메소드를 호출합니다.
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateExtHeight();
  }

  private updateExtHeight(): void {
    if (this.extContainer && this.extHeader) {
      const containerHeight = this.extContainer.nativeElement.offsetHeight;
      const headerHeight = this.extHeader.offsetHeight;
      this.bodyHeight = containerHeight - headerHeight - EXT_HEIGHT_CAL;

      if (this.extBody) {
        this.extBody.nativeElement.style.height = this.bodyHeight + 'px';
      }

      if (this.extBody2) {
        const bodyHeight2 = Math.max(
          BODY_HEIGHT_VALUE - SIDE_HEIGHT_DELTA,
          this.bodyHeight + BODY_HEIGHT_CAL);
        this.extBody2.nativeElement.style.setProperty('--side-height', bodyHeight2 + 'px');
      }
    }
  }
}
